// On-demand FullCalendar for the Appointments calendar (#19204). FullCalendar is
// a separate esbuild entry (app/javascript/fullcalendar_lib.js) so every other
// page skips it. The view renders the entry's digested URL on #calendar
// (data-fullcalendar-module-url, via fail_soft_asset_path), and its inline
// initializer calls loadFullCalendar(url) through window.GoatCalendarLoadState.
//
// The resolved library is published as window.FullCalendar — the same
// { Calendar, dayGridPlugin, timeGridPlugin, interactionPlugin } contract the
// initializer has always read. A failed load rejects (the initializer shows the
// load-failure block with Retry) and is not cached, so Retry loads again.
//
// The import goes through a plain variable so esbuild cannot constant-fold
// `import(moduleUrl)` into the application bundle — it must stay a genuine
// runtime import() (same reason as lib/background_removal.js).

let libraryPromise = null

function defaultLoader(moduleUrl) {
  const url = moduleUrl // indirection: keeps esbuild from bundling this import()
  return import(url)
}

export function resetFullCalendarCache() {
  libraryPromise = null
}

export function loadFullCalendar(moduleUrl, { loader = defaultLoader } = {}) {
  if (window.FullCalendar) return Promise.resolve(window.FullCalendar)
  if (!moduleUrl) return Promise.reject(new Error("FullCalendar module URL is missing"))

  if (!libraryPromise) {
    libraryPromise = Promise.resolve()
      .then(() => loader(moduleUrl))
      .then((mod) => {
        window.FullCalendar = {
          Calendar: mod.Calendar,
          dayGridPlugin: mod.dayGridPlugin,
          timeGridPlugin: mod.timeGridPlugin,
          interactionPlugin: mod.interactionPlugin,
        }
        return window.FullCalendar
      })
      .catch((error) => {
        libraryPromise = null // a transient failure must not poison the next try
        throw error
      })
  }
  return libraryPromise
}
